import styled, { css } from 'styled-components'
import { IconComponent } from 'LibNeo'

export const Icon = styled(IconComponent)`
	padding-left: 5px;
	overflow: unset;
	svg {
		width: 32px;
		height: 32px;
	}
`

export const HistoryBlock = styled.div`
	max-height: 210px;
	width: 250px;
	background: white;
	box-sizing: border-box;
	border-radius: 12px;
	padding: 12px 16px;
	margin-top: 16px;
	-ms-overflow-style: none;
	overflow-y: scroll;
	overflow-x: hidden;
	word-break: break-word;
	&::-webkit-scrollbar {
		width: 0;
	}
`

export const AsideBlock = styled.div<{ isFixedTableContent?: boolean }>`
    ${({ isFixedTableContent }) =>
			isFixedTableContent &&
			css`
				position: fixed;
				top: 50px;
			`}
}

	
`
